const App=({id})=>{
  return <button id={id} style={{display:'none'}}></button>
}
export default App
